// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607301848/js/" + chunkId + "." + {"44":"f451da5d","225":"09d2cacd","481":"35863f38","486":"4bc9f464","770":"85524dfa"}[chunkId] + ".0.5688472740968624.chunk.js";
};